import React from 'react';

import { ServicePageLayoutComponent } from 'design/servicePageLayout';
import { LinkControlComponent } from 'design/linkControl';
import { TextComponent } from 'design/text/textComponents';
import { useSignedIn } from 'hooks/useSignedIn';
import { DemoStackManagerAuthorized } from 'containers/DemoStackManager/DemoStackManagerAuthorized';
import { DemoStackManagerErrorFallback } from 'containers/DemoStackManager/DemoStackManagerErrorFallback';
import { ORIGIN_SITE_URL } from 'utils/constants';
import { LogoComponent } from 'design/logo';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { ImplicitAuthWidget } from 'containers/ImplicitAuthWidget';
import { ErrorBoundaryComponent } from 'utils/errorBoundary/errorBoundaryComponents';
import { OutOfResourcesError } from 'utils/errors';
import { AsyncBoundaryComponent } from 'utils/asyncBoundary/asyncBoundaryComponents';
import { SpinnerExtraLarge } from 'design/spinnerExtraLarge/spinnerExtraLargeComponents';
import { CenteredLayoutComponent } from 'design/centeredLayout/centeredLayoutComponents';
import { AccountControls } from 'containers/AccountControlls';

export const DemoStackManager = () => {
  const signedIn = useSignedIn();

  const dispatch = useAppDispatcher();

  const handleEmailConfirmed = React.useCallback(() => {
    dispatch({
      name: 'DemoStackManager__EmailConfirmed',
    });
  }, [dispatch]);

  const bodyContentNode = React.useMemo(() => {
    if (signedIn) {
      return (
        <ErrorBoundaryComponent
          errorConstructorsToCatch={[OutOfResourcesError]}
          fallbackComponent={DemoStackManagerErrorFallback}
        >
          <AsyncBoundaryComponent
            fallback={
              <CenteredLayoutComponent noOverlay>
                <SpinnerExtraLarge />
              </CenteredLayoutComponent>
            }
          >
            <DemoStackManagerAuthorized />
          </AsyncBoundaryComponent>
        </ErrorBoundaryComponent>
      );
    }

    return (
      <ImplicitAuthWidget
        target="DEMO"
        onEmailConfirmed={handleEmailConfirmed}
      />
    );
  }, [handleEmailConfirmed, signedIn]);

  return (
    <ServicePageLayoutComponent
      size="auto"
      sidebarContent={
        <LinkControlComponent to={ORIGIN_SITE_URL}>
          <TextComponent size="l">
            <LogoComponent />
          </TextComponent>
        </LinkControlComponent>
      }
      bodyContent={bodyContentNode}
      controls={<AccountControls redirectOnSignedOutTo={ORIGIN_SITE_URL} />}
    />
  );
};
